const DATA_DEFAULT = {
  password: {
    passwordStep1: '',
    passwordStep2: '',
  },
  phone: '',
};

const STATUS_DEFAULT = {
  IDLE: true,
  ERROR: false,
  LOADING: false,
  LOADED: false,
  PASSWORD_ERROR: false,
};

export {
  DATA_DEFAULT,
  STATUS_DEFAULT
};
